import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FeatureFlagsService } from '../services/feature-flags.service';

export const statisticsVisibilityGuard: CanActivateFn = (route) => {
  const featureFlags = inject(FeatureFlagsService);
  if (featureFlags.canViewUserStatistics()) {
    return true;
  }

  const router = inject(Router);
  const eventId = route.paramMap.get('id');
  return eventId
    ? router.createUrlTree(['/events', eventId])
    : router.createUrlTree(['/panel']);
};
